import React from 'react'
import { useTranslation } from "react-i18next"
import { useTheme } from "react-jss"
import invoiceTableStyle from './invoices-table-style'
import Invoice from './invoice'

export default function Invoices ({ invoices }) {
  const theme = useTheme()
  const classes = invoiceTableStyle(theme)
  const { t } = useTranslation()

  return (
    <>
      <header className={classes.tableInvoicesHeader}>
        <div>{t('account.invoices.number')}</div>
        <div>{t('account.invoices.date')}</div>
        <div>{t('account.invoices.price')}</div>
        <div>&nbsp;</div>
      </header>

      {invoices.map(invoice => <Invoice key={invoice.id} invoice={invoice} />)}
    </>
  )
}
